// eslint-disable-next-line max-classes-per-file
const Tip = require('component-tip');
const Tween = require('component-tween');
const raf = require('component-raf');
const deepExtend = require('deep-extend');
const dialog = require('dialog-component');
const q = require('queried');
const forEach = require('object-foreach');
const on = require('emmy/on');
const off = require('emmy/off');
const once = require('emmy/once');
const emit = require('emmy/emit');
const delegate = require('emmy/delegate');
const scrollTo = require('scroll-to');
const isInViewport = require('mucss/is-in-viewport');
const ajax = require('component-ajax');
const sortBy = require('lodash/sortBy');
const last = require('lodash/last');
const throttle = require('lodash/throttle');
const css = require('mucss/css');
const injectSvg = require('svg-inject');
const isBrowserWhitelisted = require('./is-browser-whitelisted');
const _ = require('./i18n');
const kudago = require('./kudago');

require('url-polyfill');

const GOOGLE_API_KEY = 'AIzaSyDkxXelJO1zmuxS6PJcjE-zdREW-C1TTNs';

const ROUBLE = '<i class="icon-rouble"></i>';

class Formatter {
  constructor(locale = kudago.language) {
    this.locale = locale;
  }

  formatNumber(number) {
    // check the first two letters in case of en-gb for instance
    switch (this.locale.substring(0, 2)) {
      case 'en':
        return splitNumber(number, ',', '.');
      case 'ru':
        return splitNumber(number, ' ', ',');
    }

    function splitNumber(num, delimiter, decimalDelimiter) {
      const [integer, fraction] = String(num).split('.');

      const formattedInteger = integer.split(/(?=(?:\d{3})+$)/g).join(delimiter);

      let formattedFraction = '';
      if (fraction && fraction.length > 3) {
        formattedFraction = decimalDelimiter + num.toFixed(3).toString().split('.')[1];
      }

      return `<span class="number-wrap">${formattedInteger + formattedFraction}</span>`;
    }
  }

  formatMoney(amount, currency = ROUBLE) {
    const num = this.formatNumber(amount);
    let parts;

    if (this.locale == 'ru') {
      parts = [num, currency];
    } else {
      parts = [currency, num];
    }

    return `<span class="money-wrap">${parts.join('&thinsp;')}</span>`;
  }
}

function roubleToSign(str) {
  const patternEn = /\s*[^-]ro?ub\w*\.?/g;
  const patternRu = /\s*руб[а-яА-ЯйЙёЁ]*\.?/g;

  [patternRu, patternEn].forEach((pattern) => {
    str = str.replace(pattern, ` ${ROUBLE}`);
  });

  return str;
}

function htmlToText(str) {
  const div = document.createElement('div');
  div.innerHTML = str;
  return div.textContent;
}

function decacheURL(url) {
  // for regex test see https://regex101.com/r/hN2zA7/1
  const [base, params, hash] = url.match(/([^?#\n]*)(\?[^#\n]*)?(#.*)?/).slice(1);

  let ts;
  if (params) {
    ts = `&ts=${+new Date()}`;
  } else {
    ts = `?ts=${+new Date()}`;
  }

  return (base || '') + (params || '') + ts + (hash || '');
}

class KudaTip extends Tip {
  constructor(...args) {
    super(...args);
    this.hidden = true;
    KudaTip.instances.push(this);
  }

  scrollHide() {
    this.scrollHandler = throttle(() => this.hide(), 500);
  }

  show(...args) {
    KudaTip.hideAll();
    super.show(...args);
    this.hidden = false;
    if (this.scrollHandler) {
      on(window, 'scroll', this.scrollHandler);
    }
  }

  hide(...args) {
    super.hide(...args);
    this.hidden = true;
    if (this.classname === 'services-dropdown-container') {
      const buttons = document.querySelectorAll('.buy-ticket');
      buttons.forEach((button) => button.classList.remove('button-disabled'));
    }
    if (this.scrollHandler) {
      off(window, 'scroll', this.scrollHandler);
    }
  }

  toggle(...args) {
    if (this.hidden) {
      this.show(...args);
    } else {
      this.hide(...args);
    }
  }

  static hideAll() {
    KudaTip.instances.forEach((item) => item.hide());
  }
}
// FIXME: array is not the best storage,
// try to use Set if we can polyfill it
KudaTip.instances = [];

/**
 * Detect is first letter symbols of the string is a russian vowel sound
 * @param  {String}  string - input string
 * @return {Boolean}        - does the first syllable begins with a vowel sound
 */
function isBeginningWithVowel(string) {
  const match = string.match(/.*?([\wа-я])/i);
  if (match) {
    const firstLetter = match[1].toLowerCase();
    if ('аоиуэы'.includes(firstLetter)) {
      return true;
    }
  }
  return false;
}

function debounce(func, delay) {
  let timer;

  function setTimer() {
    clearTimeout(timer);
    timer = setTimeout(func, delay);
  }

  return function () {
    setTimer();
  };
}

function sortArrayByField(array, field, order = 'asc') {
  const orderCoefficient = order == 'asc' ? 1 : -1;

  const sortedArray = array.sort((a, b) => {
    if (a[field] < b[field]) {
      return -1 * orderCoefficient;
    } if (a[field] > b[field]) {
      return 1 * orderCoefficient;
    }
    return 0;
  });

  return sortedArray;
}

/**
 * Gives a random integer from min to max
 * @param  {Number} min - min value (inclusive)
 * @param  {Number} max - max value (inclusive)
 * @return {Numger}     - a random number result
 * @see http://stackoverflow.com/questions/1527803/generating-random-numbers-in-javascript-in-a-specific-range
 */
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function round(x, decimals) {
  return Math.round(x * 10 ** decimals) / 10 ** decimals;
}

/**
 * Animates single value of DOM element
 * @param el        — DOM element
 * @param key       — key of the animated element
 * @param to        — final value
 * @param duration  - total time to animation
 */
function animateDOM(el, key, to, duration = 500) {
  const easing = 'out-circ';

  // setup tween
  const tween = Tween({ [key]: el[key] })
    .ease(easing)
    .to({ [key]: to })
    .duration(duration);

  // scroll
  tween.update((o) => {
    el[key] = o[key];
  });

  // animate
  let animate = function () {
    raf(animate);
    tween.update();
  };

  // handle end
  tween.on('end', () => {
    animate = function () { };
  });

  animate();
}

function isSafari(userAgent) {
  return /^((?!chrome|android).)*safari/i.test(userAgent);
}

/**
 * Create deep copy of merged objects.
 *
 * @param args
 * @returns {*}
 */
function merge(...args) {
  return deepExtend({}, ...args);
}

const AUTH_REASONS = {
  direct: {
    title: '',
    subtitle: '',
  },
  comment: {
    title: _('Log in to submit your comment'),
    subtitle: '',
  },
  contest: {
    title: _('Log in to participate in the contest'),
    subtitle: _('You will also be able to add items to favorites and leave comments'),
  },
  like: {
    title: _('Log in to add to favorites'),
    subtitle: _('You will also be able to leave comments and participate in exclusive contests'),
  },
  vote: {
    title: _('Log in to vote'),
    subtitle: _('You will also be able to leave comments and participate in exclusive contests'),
  },
};

function getTopOffset(elem, sum = 0) {
  const parent = elem.parentNode;
  return parent ? getTopOffset(parent, sum + elem.offsetTop) : sum;
}

/** Scroll view to login screen & highlight */
function scrollToEl(element, options = {}) {
  const { offset = 0, pulse = false } = options;
  // scroll to login el
  const el = q(element);

  if (!el) {
    return;
  }

  // ignore animation if is in the vp
  if (!isInViewport(el)) {
    const to = getTopOffset(el) + offset;
    scrollTo(0, to - (window.innerHeight / 5), {
      duration: 1000,
    });
  }

  // plan zoom animation
  if (pulse) {
    setTimeout(() => {
      // animate
      el.classList.add('animated');
      el.classList.add('pulse');

      // remove anim classes
      once(el, 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', () => {
        el.classList.remove('animated');
        el.classList.remove('pulse');
      });
    }, 900);
  }
}

/* --------- collapsing utill --------- */

function collapseUncollapseDetails(parent_selector, row_selector) {
  delegate(document.body, 'click', '.post-big-details__toggle-others', (e) => {
    // hide dates link is a real link to #event-dates
    // it allows to jump to the top of the block after dates collapsing
    // minimal timeout is required to make this work
    const link = e.target;
    const parent = link.parentNode;
    const container = parent.querySelector(parent_selector);
    const rows = q.all(row_selector, container);
    const more = q('.post-big-details__toggle-others--more', parent);
    const less = q('.post-big-details__toggle-others--less', parent);
    rows.forEach((row) => {
      if (!row.getAttribute('data-hidden')) {
        return;
      }

      link.setAttribute('hidden', 'hidden');
      if (link.classList.contains('post-big-details__toggle-others--more')) {
        row.removeAttribute('hidden');
        less.removeAttribute('hidden');
      } else {
        row.setAttribute('hidden', 'hidden');
        more.removeAttribute('hidden');
      }
    });
  });

  if (window.location.hash == '#event-dates'
    || window.location.hash == '#location') {
    const more = q('.post-big-details__toggle-others--more');
    emit(more, 'click', null, true);
  }
}

const closeDialog = () => {
  css(document.body, {
    overflow: null,
  });
};

/**
 * Show login dialog
 *
 * @param  {Element} - login popup element (can be overriden in tests)
 *                     we can't query the element every time because dialog
 *                     detaches the element from DOM
 * @return {void}
 */
function showLoginPopup({ reason = 'direct' }) {
  if (document.body.classList.contains('mobile')) {
    scrollToEl('#login', { pulse: true });
  } else if (q('#login')) {
    // in gtm we have split experment. initially we have
    // "#login1" and "#login2" elements.
    // in gtm we randomly choose one of them and replace to "#login"
    const clone = q('#login').cloneNode(true);
    clone.removeAttribute('hidden');

    dialog(null, clone)
      .overlay()
      .addClass('dialog-login')
      .addClass('dialog-transparent')
      .escapable()
      .on('show', () => {
        css(document.body, {
          overflow: 'hidden',
        });
      })
      .show()
      .on('close', closeDialog)
      .on('hide', closeDialog);

    const recaptchaEl = q('.future-recaptcha', clone);
    if (recaptchaEl && window.grecaptcha) {
      window.grecaptcha.render(recaptchaEl);
    }

    const title = q('.authPopup-title', clone);
    const subtitle = q('.authPopup-subtitle', clone);
    if (title && subtitle) {
      const authReason = AUTH_REASONS[reason];
      title.textContent = authReason.title;
      subtitle.textContent = authReason.subtitle;
    }
  }
}

function showGrecaptchaPopup(handlerSucces) {
  const popupClone = document.querySelector('.grecaptcha_popup').cloneNode(true);
  const grecaptchaPopupDialog = dialog(null, popupClone)
    .overlay()
    .escapable()
    .on('show', () => {
      css(document.body, {
        overflow: 'hidden',
      });
      window.grecaptcha.render(popupClone.querySelector('#grecaptcha_popup'), {
        callback: (...arg) => {
          handlerSucces(...arg).then(() => {
            closeDialog();
            grecaptchaPopupDialog.hide();
          });
        },
      });
    })
    .show()
    .on('close', closeDialog)
    .on('hide', closeDialog);
}

// correct errors handling via raven
// @see https://docs.sentry.io/clients/javascript/usage/#context-wrap
// this wrap prevents js failure in case if raven is undefined
// it also disables raven in case the code is run on unsupported platforms
function wrapInRaven(callback, ua = navigator.userAgent) {
  const { Raven } = window;

  if (Raven && isBrowserWhitelisted(ua)) {
    Raven.context(callback);
  } else {
    callback();
  }
}

function getIcon(name, attributes = {}) {
  let renderedAttributes = '';

  forEach(attributes, (value, key) => {
    if (value && key !== 'class') {
      renderedAttributes += ` ${key}="${value}"`;
    }
  });

  return `
    <i class="font-icon icon-${name} ${attributes.class || ''}" ${renderedAttributes}>
      &#x${kudago.icons[name]};
    </i>
  `;
}

const IFRAME_PROVIDERS = [
  {
    pattern: /.*(youtube\.com|youtu\.be)\/(?:watch\?v=)?([^&]+).*/,
    replacement: '//youtube.com/embed/$2',
  },
  {
    pattern: /.*vimeo\.com\/([^?]+).*/,
    replacement: '//player.vimeo.com/video/$1',
  },
];

function getIframeSrc(href) {
  let replacement = href;

  IFRAME_PROVIDERS.forEach((provider) => {
    if (provider.pattern.test(href)) {
      replacement = href.replace(provider.pattern, provider.replacement);
    }
  });

  return replacement;
}

function isUrlExternal(input) {
  const base = 'https://kudago.com';

  let url;
  try {
    url = new URL(input, base);
  } catch (e) {
    // Native URL constructor fails while parsing invalid urls e.g. 'http:'
    // so we create this relative url as a fallback
    //
    // Unfortunately this case is impossible to test
    // because PhantomJS doesn't implement URL natively
    // and 'url-polyfill' doesn't fail on invalid urls
    url = { origin: `${base}/${input}` };
  }

  return !url.origin.includes('kudago.com');
}

/**
 * Get CSRF token
 * @param  {Function} ajaxFunction - function for AJAX call making
 *                                   (useful for testing)
 */
function getCsrfToken(ajaxFunction = ajax) {
  return new Promise((resolve) => {
    ajaxFunction({
      url: '/ajax/get_csrf_token/',
      success: (data) => resolve(data.token),
    });
  });
}

// Uses in item featured items rotation (on frontend side)
// sort all f. items according their positions in array,
// where 0 element is array of all first position f. items,
// 1 element is all second position f. items etc.
function sortItemFeaturedItems(featuredItems) {
  return featuredItems.reduce((result, current) => {
    // here we need to decrease position to get array index (0 index - 1st pos.)
    const position = Number(current.getAttribute('data-ping-position')) - 1;
    if (result[position] === undefined) {
      result[position] = [];
    }
    result[position].push(current);
    return result;
  }, []);
}

const QUIZ_TYPES = {
  topScore: 'topScore',
  personal: 'personal',
};

function getResultForTopScoreQuiz(results, questions, score) {
  const resultsSortedBySums = sortBy(results, (r) => Number(r.score));
  const resultsMatchingScore = resultsSortedBySums.filter((r) => Number(r.score) <= score);
  return last(resultsMatchingScore);
}

const setBodyFixed = (fixed) => {
  const body = q(document.body);

  if (fixed) {
    const scrollY = window.pageYOffset;
    body.setAttribute('beforeFixed-scroll', scrollY);
    body.classList.add('body--fixed');
    css(body, {
      top: -Math.abs(scrollY),
    });
  } else {
    body.classList.remove('body--fixed');
    css(body, {
      top: 'inherit',
    });
    window.scrollTo(0, body.getAttribute('beforeFixed-scroll'));
  }
};

const getUserCoords = () => new Promise((resolve) => {
  if ('geolocation' in navigator) {
    // if browser supports geolocation - ask user about location
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve(position.coords);
      },
      () => { resolve(null); },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      },
    );
  } else {
    resolve(null);
  }
});

/* --------------------------- Inline svg images -------------------------------- */
const inlineSvg = (selector) => {
  q.all(selector).forEach((img) => { injectSvg(img); });
};

function initTabs() {
  q.all('.tab, .tabs > label, .tabs > a').forEach((item) => {
    on(item, 'click', () => {
      // highlight active tab
      [...item.parentNode.children].forEach((child) => {
        child.classList.remove('active');
      });

      item.classList.add('active');

      // show target element
      const target = q(`#${item.getAttribute('for')}`);
      if (target) {
        [...target.parentNode.children].forEach((child) => {
          child.classList.remove('active');
          child.setAttribute('hidden', true);
        });

        target.classList.add('active');
        target.removeAttribute('hidden');
      }
    });
  });
}

function undomify(fragment) {
  const div = document.createElement('div');
  div.appendChild(fragment.cloneNode(true));
  return div.innerHTML;
}

module.exports = {
  GOOGLE_API_KEY,
  showGrecaptchaPopup,
  Formatter,
  roubleToSign,
  htmlToText,
  decacheURL,
  KudaTip,
  isBeginningWithVowel,
  debounce,
  sortArrayByField,
  getRandomInt,
  animateDOM,
  isSafari,
  merge,
  showLoginPopup,
  wrapInRaven,
  getIcon,
  getIframeSrc,
  isUrlExternal,
  scrollToEl,
  collapseUncollapseDetails,
  getCsrfToken,
  sortItemFeaturedItems,
  QUIZ_TYPES,
  getResultForTopScoreQuiz,
  setBodyFixed,
  inlineSvg,
  getUserCoords,
  round,
  initTabs,
  undomify,
};
